import R, { useRef as Pt, useEffect as I } from "react";
var oe = { exports: {} }, B = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Me;
function jt() {
  if (Me)
    return B;
  Me = 1;
  var t = R, r = Symbol.for("react.element"), a = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, d = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(h, l, O) {
    var v, p = {}, j = null, F = null;
    O !== void 0 && (j = "" + O), l.key !== void 0 && (j = "" + l.key), l.ref !== void 0 && (F = l.ref);
    for (v in l)
      n.call(l, v) && !s.hasOwnProperty(v) && (p[v] = l[v]);
    if (h && h.defaultProps)
      for (v in l = h.defaultProps, l)
        p[v] === void 0 && (p[v] = l[v]);
    return { $$typeof: r, type: h, key: j, ref: F, props: p, _owner: d.current };
  }
  return B.Fragment = a, B.jsx = o, B.jsxs = o, B;
}
var J = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Le;
function Rt() {
  return Le || (Le = 1, process.env.NODE_ENV !== "production" && function() {
    var t = R, r = Symbol.for("react.element"), a = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), d = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), h = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), O = Symbol.for("react.suspense"), v = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), j = Symbol.for("react.lazy"), F = Symbol.for("react.offscreen"), ce = Symbol.iterator, Je = "@@iterator";
    function We(e) {
      if (e === null || typeof e != "object")
        return null;
      var i = ce && e[ce] || e[Je];
      return typeof i == "function" ? i : null;
    }
    var L = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function S(e) {
      {
        for (var i = arguments.length, u = new Array(i > 1 ? i - 1 : 0), f = 1; f < i; f++)
          u[f - 1] = arguments[f];
        Ye("error", e, u);
      }
    }
    function Ye(e, i, u) {
      {
        var f = L.ReactDebugCurrentFrame, y = f.getStackAddendum();
        y !== "" && (i += "%s", u = u.concat([y]));
        var g = u.map(function(b) {
          return String(b);
        });
        g.unshift("Warning: " + i), Function.prototype.apply.call(console[e], console, g);
      }
    }
    var Ge = !1, He = !1, qe = !1, Ke = !1, Xe = !1, de;
    de = Symbol.for("react.module.reference");
    function ze(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === n || e === s || Xe || e === d || e === O || e === v || Ke || e === F || Ge || He || qe || typeof e == "object" && e !== null && (e.$$typeof === j || e.$$typeof === p || e.$$typeof === o || e.$$typeof === h || e.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === de || e.getModuleId !== void 0));
    }
    function Ze(e, i, u) {
      var f = e.displayName;
      if (f)
        return f;
      var y = i.displayName || i.name || "";
      return y !== "" ? u + "(" + y + ")" : u;
    }
    function fe(e) {
      return e.displayName || "Context";
    }
    function V(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && S("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case n:
          return "Fragment";
        case a:
          return "Portal";
        case s:
          return "Profiler";
        case d:
          return "StrictMode";
        case O:
          return "Suspense";
        case v:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case h:
            var i = e;
            return fe(i) + ".Consumer";
          case o:
            var u = e;
            return fe(u._context) + ".Provider";
          case l:
            return Ze(e, e.render, "ForwardRef");
          case p:
            var f = e.displayName || null;
            return f !== null ? f : V(e.type) || "Memo";
          case j: {
            var y = e, g = y._payload, b = y._init;
            try {
              return V(b(g));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var M = Object.assign, $ = 0, he, me, be, ve, ye, ge, pe;
    function we() {
    }
    we.__reactDisabledLog = !0;
    function Qe() {
      {
        if ($ === 0) {
          he = console.log, me = console.info, be = console.warn, ve = console.error, ye = console.group, ge = console.groupCollapsed, pe = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: we,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        $++;
      }
    }
    function et() {
      {
        if ($--, $ === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: M({}, e, {
              value: he
            }),
            info: M({}, e, {
              value: me
            }),
            warn: M({}, e, {
              value: be
            }),
            error: M({}, e, {
              value: ve
            }),
            group: M({}, e, {
              value: ye
            }),
            groupCollapsed: M({}, e, {
              value: ge
            }),
            groupEnd: M({}, e, {
              value: pe
            })
          });
        }
        $ < 0 && S("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Z = L.ReactCurrentDispatcher, Q;
    function Y(e, i, u) {
      {
        if (Q === void 0)
          try {
            throw Error();
          } catch (y) {
            var f = y.stack.trim().match(/\n( *(at )?)/);
            Q = f && f[1] || "";
          }
        return `
` + Q + e;
      }
    }
    var ee = !1, G;
    {
      var tt = typeof WeakMap == "function" ? WeakMap : Map;
      G = new tt();
    }
    function Oe(e, i) {
      if (!e || ee)
        return "";
      {
        var u = G.get(e);
        if (u !== void 0)
          return u;
      }
      var f;
      ee = !0;
      var y = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var g;
      g = Z.current, Z.current = null, Qe();
      try {
        if (i) {
          var b = function() {
            throw Error();
          };
          if (Object.defineProperty(b.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(b, []);
            } catch (x) {
              f = x;
            }
            Reflect.construct(e, [], b);
          } else {
            try {
              b.call();
            } catch (x) {
              f = x;
            }
            e.call(b.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (x) {
            f = x;
          }
          e();
        }
      } catch (x) {
        if (x && f && typeof x.stack == "string") {
          for (var m = x.stack.split(`
`), _ = f.stack.split(`
`), N = m.length - 1, C = _.length - 1; N >= 1 && C >= 0 && m[N] !== _[C]; )
            C--;
          for (; N >= 1 && C >= 0; N--, C--)
            if (m[N] !== _[C]) {
              if (N !== 1 || C !== 1)
                do
                  if (N--, C--, C < 0 || m[N] !== _[C]) {
                    var E = `
` + m[N].replace(" at new ", " at ");
                    return e.displayName && E.includes("<anonymous>") && (E = E.replace("<anonymous>", e.displayName)), typeof e == "function" && G.set(e, E), E;
                  }
                while (N >= 1 && C >= 0);
              break;
            }
        }
      } finally {
        ee = !1, Z.current = g, et(), Error.prepareStackTrace = y;
      }
      var D = e ? e.displayName || e.name : "", Ie = D ? Y(D) : "";
      return typeof e == "function" && G.set(e, Ie), Ie;
    }
    function rt(e, i, u) {
      return Oe(e, !1);
    }
    function at(e) {
      var i = e.prototype;
      return !!(i && i.isReactComponent);
    }
    function H(e, i, u) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return Oe(e, at(e));
      if (typeof e == "string")
        return Y(e);
      switch (e) {
        case O:
          return Y("Suspense");
        case v:
          return Y("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case l:
            return rt(e.render);
          case p:
            return H(e.type, i, u);
          case j: {
            var f = e, y = f._payload, g = f._init;
            try {
              return H(g(y), i, u);
            } catch {
            }
          }
        }
      return "";
    }
    var q = Object.prototype.hasOwnProperty, Ne = {}, Ce = L.ReactDebugCurrentFrame;
    function K(e) {
      if (e) {
        var i = e._owner, u = H(e.type, e._source, i ? i.type : null);
        Ce.setExtraStackFrame(u);
      } else
        Ce.setExtraStackFrame(null);
    }
    function nt(e, i, u, f, y) {
      {
        var g = Function.call.bind(q);
        for (var b in e)
          if (g(e, b)) {
            var m = void 0;
            try {
              if (typeof e[b] != "function") {
                var _ = Error((f || "React class") + ": " + u + " type `" + b + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[b] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw _.name = "Invariant Violation", _;
              }
              m = e[b](i, b, f, u, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (N) {
              m = N;
            }
            m && !(m instanceof Error) && (K(y), S("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", f || "React class", u, b, typeof m), K(null)), m instanceof Error && !(m.message in Ne) && (Ne[m.message] = !0, K(y), S("Failed %s type: %s", u, m.message), K(null));
          }
      }
    }
    var it = Array.isArray;
    function te(e) {
      return it(e);
    }
    function lt(e) {
      {
        var i = typeof Symbol == "function" && Symbol.toStringTag, u = i && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return u;
      }
    }
    function ot(e) {
      try {
        return Pe(e), !1;
      } catch {
        return !0;
      }
    }
    function Pe(e) {
      return "" + e;
    }
    function je(e) {
      if (ot(e))
        return S("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", lt(e)), Pe(e);
    }
    var k = L.ReactCurrentOwner, st = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Re, Se, re;
    re = {};
    function ut(e) {
      if (q.call(e, "ref")) {
        var i = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (i && i.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function ct(e) {
      if (q.call(e, "key")) {
        var i = Object.getOwnPropertyDescriptor(e, "key").get;
        if (i && i.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function dt(e, i) {
      if (typeof e.ref == "string" && k.current && i && k.current.stateNode !== i) {
        var u = V(k.current.type);
        re[u] || (S('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', V(k.current.type), e.ref), re[u] = !0);
      }
    }
    function ft(e, i) {
      {
        var u = function() {
          Re || (Re = !0, S("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", i));
        };
        u.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: u,
          configurable: !0
        });
      }
    }
    function ht(e, i) {
      {
        var u = function() {
          Se || (Se = !0, S("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", i));
        };
        u.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: u,
          configurable: !0
        });
      }
    }
    var mt = function(e, i, u, f, y, g, b) {
      var m = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: e,
        key: i,
        ref: u,
        props: b,
        // Record the component responsible for creating this element.
        _owner: g
      };
      return m._store = {}, Object.defineProperty(m._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(m, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: f
      }), Object.defineProperty(m, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.freeze && (Object.freeze(m.props), Object.freeze(m)), m;
    };
    function bt(e, i, u, f, y) {
      {
        var g, b = {}, m = null, _ = null;
        u !== void 0 && (je(u), m = "" + u), ct(i) && (je(i.key), m = "" + i.key), ut(i) && (_ = i.ref, dt(i, y));
        for (g in i)
          q.call(i, g) && !st.hasOwnProperty(g) && (b[g] = i[g]);
        if (e && e.defaultProps) {
          var N = e.defaultProps;
          for (g in N)
            b[g] === void 0 && (b[g] = N[g]);
        }
        if (m || _) {
          var C = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          m && ft(b, C), _ && ht(b, C);
        }
        return mt(e, m, _, y, f, k.current, b);
      }
    }
    var ae = L.ReactCurrentOwner, _e = L.ReactDebugCurrentFrame;
    function A(e) {
      if (e) {
        var i = e._owner, u = H(e.type, e._source, i ? i.type : null);
        _e.setExtraStackFrame(u);
      } else
        _e.setExtraStackFrame(null);
    }
    var ne;
    ne = !1;
    function ie(e) {
      return typeof e == "object" && e !== null && e.$$typeof === r;
    }
    function Ee() {
      {
        if (ae.current) {
          var e = V(ae.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function vt(e) {
      {
        if (e !== void 0) {
          var i = e.fileName.replace(/^.*[\\\/]/, ""), u = e.lineNumber;
          return `

Check your code at ` + i + ":" + u + ".";
        }
        return "";
      }
    }
    var Te = {};
    function yt(e) {
      {
        var i = Ee();
        if (!i) {
          var u = typeof e == "string" ? e : e.displayName || e.name;
          u && (i = `

Check the top-level render call using <` + u + ">.");
        }
        return i;
      }
    }
    function Ve(e, i) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var u = yt(i);
        if (Te[u])
          return;
        Te[u] = !0;
        var f = "";
        e && e._owner && e._owner !== ae.current && (f = " It was passed a child from " + V(e._owner.type) + "."), A(e), S('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', u, f), A(null);
      }
    }
    function xe(e, i) {
      {
        if (typeof e != "object")
          return;
        if (te(e))
          for (var u = 0; u < e.length; u++) {
            var f = e[u];
            ie(f) && Ve(f, i);
          }
        else if (ie(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var y = We(e);
          if (typeof y == "function" && y !== e.entries)
            for (var g = y.call(e), b; !(b = g.next()).done; )
              ie(b.value) && Ve(b.value, i);
        }
      }
    }
    function gt(e) {
      {
        var i = e.type;
        if (i == null || typeof i == "string")
          return;
        var u;
        if (typeof i == "function")
          u = i.propTypes;
        else if (typeof i == "object" && (i.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        i.$$typeof === p))
          u = i.propTypes;
        else
          return;
        if (u) {
          var f = V(i);
          nt(u, e.props, "prop", f, e);
        } else if (i.PropTypes !== void 0 && !ne) {
          ne = !0;
          var y = V(i);
          S("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", y || "Unknown");
        }
        typeof i.getDefaultProps == "function" && !i.getDefaultProps.isReactClassApproved && S("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function pt(e) {
      {
        for (var i = Object.keys(e.props), u = 0; u < i.length; u++) {
          var f = i[u];
          if (f !== "children" && f !== "key") {
            A(e), S("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", f), A(null);
            break;
          }
        }
        e.ref !== null && (A(e), S("Invalid attribute `ref` supplied to `React.Fragment`."), A(null));
      }
    }
    function Fe(e, i, u, f, y, g) {
      {
        var b = ze(e);
        if (!b) {
          var m = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (m += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var _ = vt(y);
          _ ? m += _ : m += Ee();
          var N;
          e === null ? N = "null" : te(e) ? N = "array" : e !== void 0 && e.$$typeof === r ? (N = "<" + (V(e.type) || "Unknown") + " />", m = " Did you accidentally export a JSX literal instead of a component?") : N = typeof e, S("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", N, m);
        }
        var C = bt(e, i, u, y, g);
        if (C == null)
          return C;
        if (b) {
          var E = i.children;
          if (E !== void 0)
            if (f)
              if (te(E)) {
                for (var D = 0; D < E.length; D++)
                  xe(E[D], e);
                Object.freeze && Object.freeze(E);
              } else
                S("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xe(E, e);
        }
        return e === n ? pt(C) : gt(C), C;
      }
    }
    function wt(e, i, u) {
      return Fe(e, i, u, !0);
    }
    function Ot(e, i, u) {
      return Fe(e, i, u, !1);
    }
    var Nt = Ot, Ct = wt;
    J.Fragment = n, J.jsx = Nt, J.jsxs = Ct;
  }()), J;
}
process.env.NODE_ENV === "production" ? oe.exports = jt() : oe.exports = Rt();
var ue = oe.exports;
const c = ue.jsx, P = ue.jsxs, w = ue.Fragment, _t = R, Et = ({
  appEnvironment: t,
  widgetEnvironment: r,
  locale: a,
  user: n,
  navigateAs: d,
  navigateAsSelectUser: s,
  stopNavigationAs: o
}) => {
  var h, l;
  const O = Pt();
  s && ((h = O.current) === null || h === void 0 || h.addEventListener("sgwt-account-center--navigate-as-select-user", (p) => {
    const j = p;
    j && s(j.detail.user);
  })), o && ((l = O.current) === null || l === void 0 || l.addEventListener("sgwt-account-center--stop-navigation-as", (p) => {
    const j = p;
    j && o(j.detail.user);
  })), I(() => {
    O.current && typeof O.current.setUser < "u" && (O.current.widgetConfiguration.environment = r);
  }, [O.current]);
  const v = {
    authentication: "sg-connect-v2"
  };
  return n && (v.user = JSON.stringify(n), delete v.authentication), d && !(t?.toLocaleLowerCase() === "prod" || t?.toLocaleLowerCase() === "production") && (v["navigate-as"] = "", v["navigate-as-list"] = JSON.stringify(d)), c("sgwt-account-center", Object.assign({
    ref: O,
    "available-languages": "fr,en,ru",
    mode: "sg-markets",
    language: a,
    environment: t?.toLocaleLowerCase() === "prod" || t?.toLocaleLowerCase() === "production" ? "" : t
  }, v));
};
class le {
  constructor(r, a) {
    Object.defineProperty(this, "Value", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "Parent", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "PropertyName", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "ModelStateUpdater", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.Parent = r, this.PropertyName = a, this.ModelStateUpdater = void 0;
  }
  getJsonPatch() {
    if (this.Value === void 0 || !this.PropertyName)
      return;
    let r = {};
    const a = [];
    a.push(this.PropertyName), r[this.PropertyName] = this.Value;
    let n = this.Parent;
    for (; n != null; )
      if (n instanceof T && n.InputContract.isGroup())
        n = n.Parent;
      else if (n.PropertyName) {
        let o = {};
        o[n.PropertyName] = r, a.push(n.PropertyName), r = o, n = n.Parent;
      } else
        n = void 0;
    let d = "", s = a.pop();
    for (; s; )
      d = `${d}/${s}`, s = a.pop();
    return console.info(`Path to update : ${d}`), r;
  }
}
class T {
  constructor(r, a) {
    Object.defineProperty(this, "Fields", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "Parent", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "PropertyName", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "InputContract", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.Fields = /* @__PURE__ */ new Map(), this.Parent = a, this.PropertyName = r.propertyName, this.InputContract = r, r.properties.forEach((n) => {
      this.Fields.has(n.propertyName) || (n.isObject() || n.isGroup() ? this.Fields.set(n.propertyName, new T(n, this)) : n.isArray() ? this.Fields.set(n.propertyName, new X(n, this)) : this.Fields.set(n.propertyName, new le(this, n.propertyName)));
    });
  }
  getJson() {
    let r = {};
    var a = this.getFlattenedFields(this.Fields);
    return a.forEach((n, d) => {
      n instanceof T || n instanceof X ? r[d] = n.getJson() : n.Value && (r[d] = n.Value);
    }), r;
  }
  getFlattenedFields(r) {
    var a = /* @__PURE__ */ new Map();
    return r.forEach((n, d) => {
      n instanceof T && n.InputContract.isGroup() ? n.Fields.forEach((s, o) => {
        a.set(o, s);
      }) : a.set(d, n);
    }), a;
  }
  resetModel() {
    this.Fields.forEach((r) => {
      var a;
      r instanceof le ? (r.Value = void 0, (a = r.ModelStateUpdater) === null || a === void 0 || a.call(r)) : (r instanceof T || r instanceof X) && r.resetModel();
    });
  }
  applyJsonPatch(r) {
    Object.entries(r).forEach((a) => {
      var n;
      if (this.Fields.has(a[0])) {
        let d = this.Fields.get(a[0]);
        if (d instanceof T) {
          let s = a[1];
          s ? d.applyJsonPatch(s) : d.resetModel();
        } else if (d instanceof le)
          d.Value = a[1], (n = d.ModelStateUpdater) === null || n === void 0 || n.call(d);
        else if (d instanceof X) {
          let s = a[1];
          s && d.applyJsonPatch(s);
        }
      }
    }), this.Fields.forEach((a) => {
      a instanceof T && a.InputContract.isGroup() && a.applyJsonPatch(r);
    });
  }
  getRoot() {
    let r = this;
    for (; r.Parent; )
      r = r.Parent;
    return r;
  }
}
class X {
  constructor(r, a) {
    if (Object.defineProperty(this, "Value", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "Parent", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "PropertyName", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "ModelStateUpdater", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "InputContract", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.Parent = a, this.PropertyName = r.propertyName, this.ModelStateUpdater = void 0, this.InputContract = r, r.arrayItems === void 0)
      throw new Error("ArrayDataModel cannot be instantiated with an inputContract that doesn't describe arrayItems.");
  }
  resetModel() {
    this.Value = [];
  }
  applyJsonPatch(r) {
    var a;
    this.Value ? r.length < this.Value.length && this.Value.splice(r.length - 1, this.Value.length - r.length) : this.Value = [], r.forEach((n, d) => {
      var s;
      this.Value && !(this.Value[d] instanceof T) && (this.Value[d] = new T(this.InputContract.arrayItems, this)), ((s = this.Value) === null || s === void 0 ? void 0 : s[d]).applyJsonPatch(n);
    }), (a = this.ModelStateUpdater) === null || a === void 0 || a.call(this);
  }
  getJson() {
    var r;
    let a = [];
    return (r = this.Value) === null || r === void 0 || r.forEach((n, d) => {
      n instanceof T ? a[d] = n.getJson() : n.Value && (a[d] = n.Value);
    }), a;
  }
}
class se {
  constructor(r, a) {
    var n, d;
    Object.defineProperty(this, "_type", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "nullable", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "properties", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "propertyName", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "title", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "widgetType", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "arrayItems", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "enumValues", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "rank", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "colNumber", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "_isReadOnly", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "isHidden", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.propertyName = a, this.title = (n = r.title) !== null && n !== void 0 ? n : a, this._isReadOnly = r.readonly, this.isHidden = r.hidden, r.rank ? this.rank = r.rank : this.rank = 9999, r.colNumber ? this.colNumber = r.colNumber : this.colNumber = 3, Array.isArray(r.type) ? (this._type = r.type[0], this.nullable = r.type[1] == "null") : (this._type = r.type, this.nullable = !1), this.properties = Object.entries((d = r.properties) !== null && d !== void 0 ? d : []).map((s) => new se(s[1], s[0])), r.functionalType && r.functionalType !== "None" && r.type !== "array" ? this.widgetType = r.functionalType : this.widgetType = Array.isArray(r.type) ? r.type[0] : r.type, r.items && (this.arrayItems = new se(r.items, this.propertyName)), r.enum && (this.enumValues = r.enum);
  }
  isObject() {
    return this._type == "object";
  }
  isArray() {
    return this._type == "array";
  }
  isScalar() {
    return this._type != "object" && this._type != "array" && this._type != "group";
  }
  isGroup() {
    return this._type == "group";
  }
  // TODO TCN: product-input contracts have to provide them.
  isReadOnly() {
    return this._isReadOnly ? this._isReadOnly : this.propertyName == "PeriodNumber";
  }
}
const U = R.createContext({
  applyPatch: () => {
  }
}), z = (t) => {
  const r = (l) => l == null ? "" : t.inputContract.widgetType === "Date" && l === "0001-01-01" ? "1970-01-01" : t.inputContract.widgetType === "Tenor" && l === "0N" ? "" : l, [a, n] = R.useState(r(t.inputContract.widgetType === "string" && t.inputContract.enumValues && t.inputContract.enumValues.indexOf(t.objectModel.Value) === -1 ? t.inputContract.enumValues[0] : t.objectModel.Value)), {
    applyPatch: d
  } = R.useContext(U), s = (l) => {
    t.inputContract.widgetType === "integer" ? n(Number(l)) : t.inputContract.widgetType === "boolean" ? n(l === "true") : n(l);
  }, o = () => {
    n(r(t.objectModel.Value));
  };
  I(() => (t.objectModel.ModelStateUpdater ? console.error(`dynamic-screen scalar component: ${t.propertyName} already bound`) : t.objectModel.ModelStateUpdater = o.bind(void 0), () => t.objectModel.ModelStateUpdater = void 0), [t.objectModel]);
  const h = () => {
    const l = t.inputContract.widgetType === "number" || t.inputContract.widgetType === "Notional" ? Number(a) : a;
    if (r(t.objectModel.Value) !== l) {
      t.objectModel.Value = l;
      const O = t.objectModel.getJsonPatch();
      O && d(O);
    }
  };
  return t.inputContract.widgetType === "Date" ? P(w, {
    children: [t.showLabels && c("label", Object.assign({
      className: "text-secondary",
      htmlFor: t.propertyName
    }, {
      children: t.inputContract.title
    })), t.showLabels ? c("input", {
      id: t.propertyName,
      type: "date",
      readOnly: t.inputContract.isReadOnly(),
      className: "form-control",
      value: new Date(a).toLocaleDateString("sv-SE"),
      onChange: (l) => s(l.target.value),
      onBlur: h
    }) : c(w, {
      children: new Date(a).toLocaleDateString("sv-SE")
    })]
  }) : t.inputContract.widgetType === "DateTime" ? P(w, {
    children: [t.showLabels && c("label", Object.assign({
      className: "text-secondary",
      htmlFor: t.propertyName
    }, {
      children: t.inputContract.title
    })), t.showLabels ? c("input", {
      id: t.propertyName,
      type: "date",
      readOnly: t.inputContract.isReadOnly(),
      className: "form-control",
      value: new Date(a).toLocaleString("sv-SE"),
      onChange: (l) => s(l.target.value),
      onBlur: h
    }) : c(w, {
      children: new Date(a).toLocaleString("sv-SE")
    })]
  }) : t.inputContract.widgetType === "boolean" ? P(w, {
    children: [t.showLabels && c("label", Object.assign({
      className: "text-secondary",
      htmlFor: t.propertyName
    }, {
      children: t.inputContract.title
    })), c("input", {
      id: t.propertyName,
      type: "checkbox",
      readOnly: t.inputContract.isReadOnly(),
      pattern: "\\d*",
      className: "form-control",
      checked: a,
      onChange: (l) => s(String(l.target.checked)),
      onBlur: h
    })]
  }) : t.inputContract.widgetType === "string" || t.inputContract.widgetType === "Currency" || t.inputContract.widgetType === "Tenor" || t.inputContract.widgetType === "TenorBucket" || t.inputContract.widgetType === "BusinessDayConvention" || t.inputContract.widgetType === "BdrParty" || t.inputContract.widgetType === "RateIndex" ? P(w, {
    children: [t.showLabels && c("label", Object.assign({
      className: "text-secondary",
      htmlFor: t.propertyName
    }, {
      children: t.inputContract.title
    })), t.showLabels ? c("input", {
      id: t.propertyName,
      type: "text",
      readOnly: t.inputContract.isReadOnly(),
      className: "form-control",
      value: a,
      onChange: (l) => s(l.target.value),
      onBlur: h
    }) : c(w, {
      children: a
    })]
  }) : t.inputContract.widgetType === "number" || t.inputContract.widgetType === "Notional" ? P(w, {
    children: [t.showLabels && c("label", Object.assign({
      className: "text-secondary",
      htmlFor: t.propertyName
    }, {
      children: t.inputContract.title
    })), t.showLabels ? c("input", {
      id: t.propertyName,
      type: "numeric",
      readOnly: t.inputContract.isReadOnly(),
      className: "form-control text-right",
      value: a,
      onChange: (l) => s(l.target.value),
      onBlur: h
    }) : c(w, {
      children: a
    })]
  }) : t.inputContract.widgetType === "integer" ? P(w, {
    children: [t.showLabels && c("label", Object.assign({
      className: "text-secondary",
      htmlFor: t.propertyName
    }, {
      children: t.inputContract.title
    })), t.showLabels ? c("input", {
      id: t.propertyName,
      type: "numeric",
      readOnly: t.inputContract.isReadOnly(),
      pattern: "\\d*",
      className: "form-control text-right",
      value: a,
      onChange: (l) => s(l.target.value),
      onBlur: h
    }) : c(w, {
      children: a
    })]
  }) : P(w, {
    children: [t.inputContract.title, " unknown widget type ", t.inputContract.widgetType]
  });
};
z.defaultProps = {
  showLabels: !0
};
const Ae = ({
  propertyName: t,
  inputContract: r,
  nestedLevel: a,
  arrayModel: n
}) => {
  var d;
  const [s, o] = R.useState([...(d = n.Value) !== null && d !== void 0 ? d : []]), h = () => {
    var l;
    o([...(l = n.Value) !== null && l !== void 0 ? l : []]);
  };
  return I(() => (n.ModelStateUpdater && console.error(`dynamic-screen array component: ${t} already bound`), n.ModelStateUpdater = () => h(), () => n.ModelStateUpdater = void 0), []), r.isArray() && r.arrayItems ? c(w, {
    children: P("div", Object.assign({
      className: "d-flex flex-column m-3 border"
    }, {
      children: [c("div", Object.assign({
        className: "bg-lvl2 p-1"
      }, {
        children: r.title
      })), c("div", Object.assign({
        className: "m-2"
      }, {
        children: P("div", Object.assign({
          className: "container"
        }, {
          children: [r.arrayItems.isObject() && c("div", Object.assign({
            className: "row m-1"
          }, {
            children: r.arrayItems.properties.map((l) => c("div", Object.assign({
              className: "text-secondary col font-xs"
            }, {
              children: l.title
            }), l.propertyName))
          })), s?.map((l) => c(w, {
            children: l instanceof T ? c("div", Object.assign({
              className: "row m-1"
            }, {
              children: c(W, {
                displayStyle: "inline",
                nestedLevel: a + 1,
                objectModel: l
              }, r.propertyName)
            })) : c("div", Object.assign({
              className: "row m-1"
            }, {
              children: c(z, {
                propertyName: r.propertyName,
                inputContract: r.arrayItems,
                objectModel: l
              }, r.propertyName)
            }))
          }))]
        }))
      }))]
    }))
  }) : c(w, {});
}, De = (t) => {
  const r = (l) => l ?? "", a = t.objectModel.Fields.get("BdrMnemonic"), [n, d] = R.useState(r(a.Value)), {
    applyPatch: s
  } = R.useContext(U), o = () => {
    d(r(a.Value));
  };
  I(() => (a.ModelStateUpdater ? console.error(`dynamic-screen BdrParty component: ${t.propertyName} already bound`) : a.ModelStateUpdater = o.bind(void 0), () => a.ModelStateUpdater = void 0), [t.objectModel]);
  const h = () => {
    if (r(a.Value) !== n) {
      a.Value = n;
      const l = a.getJsonPatch();
      l && s(l);
    }
  };
  return P("div", Object.assign({
    className: `form-group col-md-${t.inputContract.colNumber}`
  }, {
    children: [t.showLabels && c("label", Object.assign({
      className: "text-secondary",
      htmlFor: t.propertyName
    }, {
      children: t.inputContract.title
    })), t.showLabels ? c("input", {
      id: t.propertyName,
      type: "text",
      readOnly: t.inputContract.isReadOnly(),
      className: "form-control",
      value: n,
      onChange: (l) => d(l.target.value),
      onBlur: h
    }) : c(w, {
      children: n
    })]
  }));
};
De.defaultProps = {
  showLabels: !0
};
const Ue = (t) => {
  const r = (l) => l ?? "", a = t.objectModel.Fields.get("BdrMnemonic"), [n, d] = R.useState(r(a.Value)), {
    applyPatch: s
  } = R.useContext(U), o = () => {
    d(r(a.Value));
  };
  I(() => (a.ModelStateUpdater ? console.error(`dynamic-screen BdrPortfolio component: ${t.propertyName} already bound`) : a.ModelStateUpdater = o.bind(void 0), () => a.ModelStateUpdater = void 0), [t.objectModel]);
  const h = () => {
    if (r(a.Value) !== n) {
      a.Value = n;
      const l = a.getJsonPatch();
      l && s(l);
    }
  };
  return P("div", Object.assign({
    className: `form-group col-md-${t.inputContract.colNumber}`
  }, {
    children: [t.showLabels && c("label", Object.assign({
      className: "text-secondary",
      htmlFor: t.propertyName
    }, {
      children: t.inputContract.title
    })), t.showLabels ? c("input", {
      id: t.propertyName,
      type: "text",
      readOnly: t.inputContract.isReadOnly(),
      className: "form-control",
      value: n,
      onChange: (l) => d(l.target.value),
      onBlur: h
    }) : c(w, {
      children: n
    })]
  }));
};
Ue.defaultProps = {
  showLabels: !0
};
const $e = (t) => {
  const r = (l) => l ?? "", a = t.objectModel.Fields.get("BdrInitials"), [n, d] = R.useState(r(a.Value)), {
    applyPatch: s
  } = R.useContext(U), o = () => {
    d(r(a.Value));
  };
  I(() => (a.ModelStateUpdater ? console.error(`dynamic-screen XOneUser component: ${t.propertyName} already bound`) : a.ModelStateUpdater = o.bind(void 0), () => a.ModelStateUpdater = void 0), [t.objectModel]);
  const h = () => {
    if (r(a.Value) !== n) {
      a.Value = n;
      const l = a.getJsonPatch();
      l && s(l);
    }
  };
  return P("div", Object.assign({
    className: `form-group col-md-${t.inputContract.colNumber}`
  }, {
    children: [t.showLabels && c("label", Object.assign({
      className: "text-secondary",
      htmlFor: t.propertyName
    }, {
      children: t.inputContract.title
    })), t.showLabels ? c("input", {
      id: t.propertyName,
      type: "text",
      readOnly: t.inputContract.isReadOnly(),
      className: "form-control",
      value: n,
      onChange: (l) => d(l.target.value),
      onBlur: h
    }) : c(w, {
      children: n
    })]
  }));
};
$e.defaultProps = {
  showLabels: !0
};
const ke = ({
  propertyName: t,
  inputContract: r,
  objectModel: a,
  showLabels: n
}) => {
  const d = (v) => {
    if (v == null)
      return NaN;
    const p = v;
    return p ? p * 100 : v;
  }, [s, o] = R.useState(d(a.Value)), {
    applyPatch: h
  } = R.useContext(U), l = () => {
    o(d(a.Value));
  };
  I(() => (a.ModelStateUpdater ? console.error(`dynamic-screen Rate component: ${t} already bound`) : a.ModelStateUpdater = l.bind(void 0), () => a.ModelStateUpdater = void 0), [a]);
  const O = () => {
    if (d(a.Value) !== s) {
      a.Value = s / 100;
      const v = a.getJsonPatch();
      v && h(v);
    }
  };
  return P(w, {
    children: [n && c("label", Object.assign({
      className: "text-secondary",
      htmlFor: t
    }, {
      children: r.title
    })), n ? P("div", Object.assign({
      className: "input-group"
    }, {
      children: [c("input", {
        id: t,
        type: "numeric",
        readOnly: r.isReadOnly(),
        className: "form-control text-right",
        value: s,
        onChange: (v) => o(v.target.value),
        onBlur: O
      }), c("div", Object.assign({
        className: "input-group-append"
      }, {
        children: c("span", Object.assign({
          className: "input-group-text"
        }, {
          children: "%"
        }))
      }))]
    })) : c(w, {
      children: s
    })]
  });
};
ke.defaultProps = {
  showLabels: !0
};
const Be = ({
  propertyName: t,
  inputContract: r,
  objectModel: a,
  enumValues: n,
  showLabels: d
}) => {
  const s = (p) => {
    var j;
    const F = p;
    return F && n.indexOf(F) !== -1 ? F : (j = n[0]) !== null && j !== void 0 ? j : "";
  }, [o, h] = R.useState(s(a.Value)), {
    applyPatch: l
  } = R.useContext(U), O = () => {
    h(s(a.Value));
  };
  I(() => (a.ModelStateUpdater ? console.error(`dynamic-screen Select component: ${t} already bound`) : (a.ModelStateUpdater = O.bind(void 0), v()), () => a.ModelStateUpdater = void 0), [a]);
  const v = () => {
    if (a.Value !== o) {
      a.Value = o;
      const p = a.getJsonPatch();
      p && l(p);
    }
  };
  return P(w, {
    children: [d && c("label", Object.assign({
      className: "text-secondary",
      htmlFor: t
    }, {
      children: r.title
    })), d ? c("select", Object.assign({
      id: t,
      disabled: r.isReadOnly(),
      className: "form-control",
      value: o,
      onChange: (p) => h(p.target.value),
      onBlur: v
    }, {
      children: n.map((p) => c("option", Object.assign({
        value: p
      }, {
        children: p
      })))
    })) : c(w, {
      children: o
    })]
  });
};
Be.defaultProps = {
  showLabels: !0
};
const W = ({
  nestedLevel: t,
  objectModel: r,
  displayStyle: a,
  showTitle: n,
  overrides: d
}) => {
  if (a === "box") {
    const s = c("div", Object.assign({
      className: `d-flex flex-row flex-wrap justify-content-begin ${t === 0 ? "" : "m-2"}`
    }, {
      children: r.InputContract.properties.filter((o) => !o.isHidden).map((o) => {
        var h;
        const l = (h = d?.find((O) => O.isMatch(o))) !== null && h !== void 0 ? h : void 0;
        if (l !== void 0)
          return l.component({
            property: o,
            model: r.Fields.get(o.propertyName)
          });
        if (o.isGroup())
          return c(W, {
            displayStyle: "box",
            nestedLevel: t + 1,
            objectModel: r.Fields.get(o.propertyName),
            showTitle: !1,
            overrides: d
          }, o.propertyName);
        if (o.isScalar())
          return c("div", Object.assign({
            className: `form-group col-md-${o.colNumber}`
          }, {
            children: o.widgetType === "Rate" ? c(w, {
              children: c(ke, {
                propertyName: o.propertyName,
                inputContract: o,
                objectModel: r.Fields.get(o.propertyName)
              }, o.propertyName)
            }) : o.widgetType === "string" && o.enumValues ? c(w, {
              children: c(Be, {
                propertyName: o.propertyName,
                inputContract: o,
                enumValues: o.enumValues,
                objectModel: r.Fields.get(o.propertyName)
              }, o.propertyName)
            }) : c(z, {
              propertyName: o.propertyName,
              inputContract: o,
              objectModel: r.Fields.get(o.propertyName)
            }, o.propertyName)
          }));
        if (o.isObject())
          switch (o.widgetType) {
            case "Filler":
              return c("div", {
                className: `form-group col-md-${o.colNumber}`
              });
            case "BdrParty":
              return c(De, {
                propertyName: o.propertyName,
                inputContract: o,
                objectModel: r.Fields.get(o.propertyName)
              }, o.propertyName);
            case "BdrPortfolio":
              return c(Ue, {
                propertyName: o.propertyName,
                inputContract: o,
                objectModel: r.Fields.get(o.propertyName)
              }, o.propertyName);
            case "XOneUser":
              return c($e, {
                propertyName: o.propertyName,
                inputContract: o,
                objectModel: r.Fields.get(o.propertyName)
              }, o.propertyName);
            default:
              return c(W, {
                displayStyle: "box",
                nestedLevel: t + 1,
                objectModel: r.Fields.get(o.propertyName),
                overrides: d
              }, o.propertyName);
          }
        return o.isArray() ? c(Ae, {
          propertyName: o.propertyName,
          inputContract: o,
          nestedLevel: t + 1,
          arrayModel: r.Fields.get(o.propertyName)
        }, o.propertyName) : c(w, {});
      })
    }));
    return P("div", Object.assign({
      className: `d-flex flex-column col-md-12 p-0 ${t > 1 ? "mb-2 mt-2" : t === 1 ? "m-1" : ""} ${t === 0 || !n ? "" : "border border-primary"}`
    }, {
      children: [t > 0 && n && P("details", Object.assign({
        open: !0,
        className: "col-md-12 p-0"
      }, {
        children: [c("summary", Object.assign({
          className: "btn btn-primary shadow-none text-left col-md-12",
          tabIndex: -1
        }, {
          children: r.InputContract.title
        })), c("div", {
          children: s
        })]
      })), (t === 0 || !n) && s]
    }));
  }
  return P(w, {
    children: [r.InputContract.properties.filter((s) => s.isScalar() && !s.isHidden).map((s) => c("div", Object.assign({
      className: "col"
    }, {
      children: c(z, {
        showLabels: !1,
        propertyName: s.propertyName,
        inputContract: s,
        objectModel: r.Fields.get(s.propertyName)
      }, s.propertyName)
    }))), r.InputContract.properties.filter((s) => s.isObject() && !s.isHidden).map((s) => c("div", Object.assign({
      className: "col"
    }, {
      children: c(W, {
        displayStyle: "box",
        nestedLevel: t + 1,
        objectModel: r.Fields.get(s.propertyName)
      }, s.propertyName)
    }))), r.InputContract.properties.filter((s) => s.isArray() && !s.isHidden).map((s) => c("div", Object.assign({
      className: "col"
    }, {
      children: c(Ae, {
        propertyName: s.propertyName,
        inputContract: s,
        nestedLevel: t + 1,
        arrayModel: r.Fields.get(s.propertyName)
      }, s.propertyName)
    })))]
  });
};
W.defaultProps = {
  showTitle: !0
};
class Tt {
  constructor(r, a, n, d, s, o, h, l, O) {
    Object.defineProperty(this, "Response", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "Location", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "Error", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "ErrorString", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "KycCheck", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "Deal", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "SessionId", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "Message", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "StatusCode", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.Response = r, this.Location = a, this.Error = n, this.ErrorString = d, this.KycCheck = s, this.Deal = o, this.SessionId = h, this.Message = l, this.StatusCode = O;
  }
}
export {
  Et as AccountCenter,
  _t as AccountCenterReact,
  Ae as ArrayComponent,
  X as ArrayDataModel,
  De as BdrPartyComponent,
  se as DataContract,
  U as DynamicScreenContext,
  le as KeyDataModel,
  W as ObjectComponent,
  T as ObjectDataModel,
  Tt as PdcHubApiResponse,
  z as ScalarComponent
};
//# sourceMappingURL=main.es.js.map
